export default __webpack_public_path__ + "static/media/pg-8.dc30fdf0.jpg";